export const SET_IT_CLOUD_SELECTED_OPTION = 'SET_IT_CLOUD_SELECTED_OPTION';
export const RESET_IT_CLOUD_SELECTED_OPTION = 'RESET_IT_CLOUD_SELECTED_OPTION';

export const setSelectedOption = (option) => ({
    type: SET_IT_CLOUD_SELECTED_OPTION,
    payload: option,
});

export const resetSelectedOption = () => ({
    type: RESET_IT_CLOUD_SELECTED_OPTION,
});
